import { HttpErrorResponse } from "@angular/common/http";
import { MatSnackBarRef } from "@angular/material/snack-bar";
import { Observable, ObservedValueOf, OperatorFunction, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { NotificationConfig } from "app/shared/util/notification.service";
import { NotificationComponent } from "app/shared/notification/notification.component";



export function createResizeObservable(container: HTMLElement): Observable<DOMRect> {
  return new Observable<DOMRect>((subscriber) => {
    const resizeObserver = new ResizeObserver((entries) => {
      const rect = entries[0].target.getBoundingClientRect();

      subscriber.next(
        new DOMRect(
          Math.floor(rect.left),
          Math.floor(rect.top),
          Math.floor(rect.width),
          Math.floor(rect.height)
        )
      );
    });

    resizeObserver.observe(container);
    return function unsubscribe(): void {
      resizeObserver.disconnect();
    };
  });
}

export function showPredefinedError<T>(
  notification: {
    openError: (msg: App.NotificationMessageType, config?: NotificationConfig) => MatSnackBarRef<NotificationComponent>;
  },
  defaultMessages: {
    default: App.NotificationMessageType;
    [key: number]: App.NotificationMessageType;
  }
): OperatorFunction<T, T | ObservedValueOf<T>> {
  return (source) => {
    return source
      .pipe(
        catchError((res: HttpErrorResponse) => {
          if (res.error?.message) {
            notification.openError(res.error.message);
          } else if (defaultMessages[res.status]) {
            notification.openError(defaultMessages[res.status]);
          } else if (defaultMessages.default) {
            notification.openError(defaultMessages.default);
          }
          return throwError(res);
        })
      )
  };
}
